
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../../common/client/sagas/common';

import { sagas as mapSagas } from '../../map';

import {
    SET_TYPE,
    UPDATE_OBJECT_EDIT
} from './info';

import {
    DATAWIN_SET_OBJECT_LIST,
    DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST
} from './datawin';

import {
    INFO_TYPE_HOME,
    INFO_TYPE_OBJECT,
} from '../reducers/infoPanelType';

import server from '../server';

export const DATA_OPERATION_ACTION_TYPE = createActionTypes('data/OPERATION');
export const DELETE_OBJECT = 'data/operation/DELETE_OBJECT';
export const FETCH_OBJECTS = 'data/operation/FETCH_OBJECTS';
export const INSERT_OBJECT = 'data/operation/INSERT_OBJECT';
export const UPDATE_OBJECT = 'data/operation/UPDATE_OBJECT';
export const UPDATE_ATTRIBUTE_FOR_OBJECTS = 'data/operation/UPDATE_ATTRIBUTE_FOR_OBJECTS';

export default function getActions(dispatch) {
    return {
        deleteObject: (token, projectId, dataModelItemId, mapLayerId, params) => dispatch({
            type: DELETE_OBJECT,
            token, projectId, dataModelItemId, mapLayerId, params,
            operation: 'delete'
        }),
        fetchObjects: (token, projectId, dataModelItemId, mapLayerId, params) => dispatch({
            type: FETCH_OBJECTS,
            token, projectId, dataModelItemId, mapLayerId, params,
            operation: 'get'
        }),
        insertObject: (token, projectId, dataModelItemId, mapLayerId, params) => dispatch({
            type: INSERT_OBJECT,
            token, projectId, dataModelItemId, mapLayerId, params,
            operation: 'insert'
        }),
        updateObject: (token, projectId, dataModelItemId, mapLayerId, params) => dispatch({
            type: UPDATE_OBJECT,
            token, projectId, dataModelItemId, mapLayerId, params,
            operation: 'update'
        }),
        updateAttributeForObjects: (token, projectId, dataModelItemId, params) => dispatch({
            type: UPDATE_ATTRIBUTE_FOR_OBJECTS,
            token, projectId, dataModelItemId, params,
            operation: 'updateAttributeForObjects'
        })
    };
}

function* afterSuccessDeleteOperation(action, result) {
    yield put({type: SET_TYPE, panelType: INFO_TYPE_HOME});
    yield put({type: mapSagas.ADD_COMMAND, name: 'REDRAW', params: {layers: [action.mapLayerId]}});
}

function* afterSuccessFetchObjectsOperation(action, result) {
    yield put({
        type: DATAWIN_SET_OBJECT_LIST,
        mode: action.params.mode,
        id: action.dataModelItemId,
        objectList: result.objects.map(item => {
            return {
                attributes: item,
                layerId: action.mapLayerId
            }
        })
    });

}

function* afterSuccessInsertOperation(action, result) {
    yield put({type: SET_TYPE, panelType: INFO_TYPE_HOME});
    yield put({type: mapSagas.ADD_COMMAND, name: 'REDRAW', params: {layers: [action.mapLayerId]}});
}

function* afterSuccessUpdateOperation(action, result) {
    const {type, ...params} = action;
    yield put({type: UPDATE_OBJECT_EDIT, params, object: result.object});
    yield put({type: SET_TYPE, panelType: INFO_TYPE_OBJECT});
    yield put({type: mapSagas.ADD_COMMAND, name: 'REDRAW', params: {layers: [action.mapLayerId]}});
}

function* afterSuccessUpdateAttributeForObjectsOperation(action, result) {
    yield put({
        type: DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST,
        dataModelItemId: action.dataModelItemId,
        ...action.params
    });
}

function execOperation(action) {
    return new Promise((resolve, reject) => {
        server.data.execOperation(
            action.token, action.projectId, action.operation,
            action.dataModelItemId, action.params, action.clientOptions, action.debug,
            (err, result) => {
                if (result) {
                    resolve(result);
                } else {
                    reject(err);
                }
            }
        );
    });
}

function* workExecOperation(options, funcCallApi, funcSuccess, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: DATA_OPERATION_ACTION_TYPE.DEFAULT});
        const result = yield call(funcCallApi, action);
        yield put({type: DATA_OPERATION_ACTION_TYPE.SUCCESS, result});
        if (result.success) {
            yield call(funcSuccess, action, result);
        }
        yield call(checkOperationResult, result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, DATA_OPERATION_ACTION_TYPE);
    }
}

export function* watchDeleteObject(options) {
    yield takeEvery(
        DELETE_OBJECT, workExecOperation, options,
        execOperation, afterSuccessDeleteOperation, 'Smazání objektu'
    );
}

export function* watchFetchObjects(options) {
    yield takeEvery(
        FETCH_OBJECTS, workExecOperation, options,
        execOperation, afterSuccessFetchObjectsOperation, 'Načtení objektů'
    );
}

export function* watchInsertObject(options) {
    yield takeEvery(
        INSERT_OBJECT, workExecOperation, options,
        execOperation, afterSuccessInsertOperation, 'Vytvoření nového objektu'
    );
}

export function* watchUpdateObject(options) {
    yield takeEvery(
        UPDATE_OBJECT, workExecOperation, options,
        execOperation, afterSuccessUpdateOperation, 'Uložení změn existujícího objektu'
    );
}

export function* watchUpdateAttributeForObjects(options) {
    yield takeEvery(
        UPDATE_ATTRIBUTE_FOR_OBJECTS, workExecOperation, options,
        execOperation, afterSuccessUpdateAttributeForObjectsOperation, 'Hromadné přepsání atributu u objektů'
    );
}
